import React from 'react';

import Wysiwyg from '../Wysiwyg';
import { Block } from './styles';
import { ThemeProvider } from 'styled-components';
import { themes } from '../../ui/design-tokens';

interface IProps {
  theme: string;
  heading: string;
  subtitle?: string;
  title?: string;
  textColor?: string;
  text: string;
}

const FeaturedText = ({ theme, heading, subtitle, title, textColor, text }: IProps) => {
  const cleanedTheme = theme ? theme : 'white';
  if (textColor === 'franchises_dark' || textColor === 'white' ) textColor = 'neutral';
  if (textColor === 'franchises_light') textColor = 'franquicias';
  const cleanedColor = textColor ? textColor : cleanedTheme;
  const formattedText = `<p>${text}</p>`;
  return (
    <ThemeProvider theme={themes.basic[cleanedTheme]}>
      <Block textColor={cleanedColor}>
        {subtitle && <p className={'subtitle'}>{subtitle}</p>}
        <Wysiwyg
          heading={heading}
          title={title}
          text={formattedText}
          component
          theme={cleanedTheme}
          className={`wysiwyg ${textColor !== 'neutral' && theme !== 'neutral' && 'coloredText'}`}
        />
      </Block>
    </ThemeProvider>
  );
};

export default FeaturedText;
